import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Hero from '../components/landing/Hero';
import HowItWorks from '../components/landing/HowItWorks';
// Footer removed from landing page — legal links on signup + settings

const NAV_HEIGHT = 64;

const sectionStyle: React.CSSProperties = {
  scrollSnapAlign: 'start',
  scrollSnapStop: 'always',
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleForgeClick = () => {
    navigate('/signup');
  };

  return (
    <>
      <style>{`
        .landing-scroll-container {
          height: 100dvh;
          overflow-y: auto;
          scroll-snap-type: y mandatory;
          scroll-behavior: smooth;
          scroll-padding-top: ${NAV_HEIGHT}px;
        }
        @media (min-width: 769px) {
          .landing-scroll-container {
            scroll-snap-type: none;
          }
          .landing-scroll-container .snap-section {
            scroll-snap-align: unset;
            scroll-snap-stop: unset;
            min-height: auto;
          }
        }
      `}</style>

      {/* Nav Bar */}
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 'calc(env(safe-area-inset-top, 12px) + 15px) 22px 13px',
        background: 'linear-gradient(180deg, rgba(8,8,13,0.98), rgba(8,8,13,0.92))',
        backdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(201,168,76,0.1)',
        minHeight: `${NAV_HEIGHT}px`,
        boxSizing: 'border-box',
      }}>
        <span style={{
          fontFamily: "Cinzel, serif",
          maxWidth: '145px',
          fontSize: '16px',
          lineHeight: 1.45,
          letterSpacing: '3.5px',
          color: '#c9a84c',
          textShadow: '0 0 18px rgba(201,168,76,0.12)',
        }}>ZEAL GENESIS™</span>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
          {isAuthenticated ? (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: '8px 24px',
                fontSize: '13px',
                color: '#0a0a0f',
                background: 'linear-gradient(135deg, #c9a84c, #e8d48b)',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 600,
                letterSpacing: '0.5px',
              }}
            >
              My Dashboard →
            </button>
          ) : (
            <>
              <button
                onClick={() => navigate('/login')}
                style={{
                  minHeight: '42px',
                  padding: '8px 13px',
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.78)',
                  background: 'rgba(255,255,255,0.025)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 600,
                  letterSpacing: '0.5px',
                  whiteSpace: 'nowrap',
                }}
              >
                Log In
              </button>
              <button
                onClick={() => navigate('/signup')}
                style={{
                  minHeight: '42px',
                  padding: '8px 13px',
                  fontSize: '12px',
                  color: '#e7cc73',
                  background: 'rgba(201,168,76,0.06)',
                  border: '1px solid rgba(201,168,76,0.55)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 600,
                  letterSpacing: '0.5px',
                  whiteSpace: 'nowrap',
                }}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      </nav>

      <div className="landing-scroll-container">
        <div className="snap-section" style={sectionStyle}>
          <Hero onForgeClick={handleForgeClick} />
        </div>
        <div className="snap-section" style={sectionStyle}>
          <HowItWorks />
        </div>

      </div>
    </>
  );
};

export default LandingPage;
